// src/lib/nativeBridge.ts
declare global {
    interface Window {
        Android?: { goHome?: () => any };
    }
}

export function hasAndroidGoHome(): boolean {
    return (
        typeof window !== "undefined" &&
        !!window.Android &&
        typeof window.Android.goHome === "function"
    );
}

export function goNativeHome(): boolean {
    try {
        if (hasAndroidGoHome()) {
            const ret = window.Android!.goHome!();
            console.log("[Bridge] Android.goHome() called, return =", ret);
            return true; // 네이티브 호출 성공
        } else {
            console.warn("[Bridge] Android.goHome() 미탑재 환경");
            return false; // 브릿지 없음
        }
    } catch (e) {
        console.error("[Bridge] goHome 호출 실패:", e);
        return false; // 호출 실패
    }
}
